import type { FC } from 'react';
import React, { useMemo } from 'react';
import cn from 'classnames';

import type { TMainMenu } from './models';

export const MainMenu: FC<TMainMenu> = ({
    DataLayer,
    MENU_ITEMS_CONFIG,
    MenuBanner,
    banner,
    bannerProps,
    menuItems,
    styles,
}) => {
    const bannerRender = useMemo(() => {
        if (banner) return banner;
        if (bannerProps) {
            return (
                <ul className={cn(styles.external, styles.menuColumn, styles.menuBanner)}>
                    <MenuBanner {...bannerProps} />
                </ul>
            );
        }

        return null;
    }, [MenuBanner, banner, bannerProps, styles]);

    return (
        <>
            {menuItems.map((el, idx) => {
                return (
                    <ul
                        key={idx}
                        className={cn(styles.external, styles.menuColumn, {
                            [styles.divided]: idx > 0,
                        })}
                    >
                        {el.map(props => {
                            const type = props.type ?? 'link';
                            const MenuItem = MENU_ITEMS_CONFIG[type];

                            return (
                                <li
                                    key={props.title}
                                    className={cn({ [styles.header]: props.type === 'header' })}
                                >
                                    <DataLayer data={props.analytics} tag="div">
                                        <MenuItem {...props}>{props.title}</MenuItem>
                                    </DataLayer>
                                </li>
                            );
                        })}
                    </ul>
                );
            })}
            {bannerRender}
        </>
    );
};
